var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { setEntityField, setStateField } from "framework/state/entity";
import { NoEntityError } from "framework/validation/validatableentity";
import { apiUpdateCurrentAccountCookieConsent } from "./endpoint";
import { load } from "framework/state/loader";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { showDialog: false, initialized: false, cookieMeasurement: false, cookieMarketing: false, consentGiven: false, consentGivenOn: null, consentSavedToCurrentAccount: false, entity: {
        cookieMeasurement: false,
        cookieMarketing: false,
    }, errors: __assign({}, NoEntityError) });
var saveToCurrentUserAccount = function () { return function (store) {
    var state = store.getState();
    var consent_data = {
        consentGiven: state.consentGiven,
        cookieMeasurement: state.cookieMeasurement,
        cookieMarketing: state.cookieMarketing,
    };
    var loader = function () { return apiUpdateCurrentAccountCookieConsent(consent_data); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                draft.consentSavedToCurrentAccount = true;
            });
        }
    };
    load(store, loader, stateProducer);
}; };
var saveToLocalStorage = function (cookieMeasurement, cookieMarketing, consentGiven, consentGivenOn) {
    localStorage.setItem('cookie_measurement', String(cookieMeasurement));
    localStorage.setItem('cookie_marketing', String(cookieMarketing));
    localStorage.setItem('consent_given', String(consentGiven));
    localStorage.setItem('consent_given_on', String(consentGivenOn));
};
var openDialog = function () { return function (store) {
    store.setState(function (draft) {
        draft.showDialog = true;
    });
}; };
var agreeWithSelected = function () { return function (store) {
    store.setState(function (draft) {
        draft.showDialog = false;
        draft.cookieMeasurement = draft.entity.cookieMeasurement;
        draft.cookieMarketing = draft.entity.cookieMarketing;
        draft.consentGiven = true;
        draft.consentGivenOn = new Date();
        saveToLocalStorage(draft.cookieMeasurement, draft.cookieMarketing, draft.consentGiven, draft.consentGivenOn);
    });
}; };
var agreeWithAll = function () { return function (store) {
    store.setState(function (draft) {
        draft.showDialog = false;
        draft.cookieMeasurement = true;
        draft.cookieMarketing = true;
        draft.consentGiven = true;
        draft.consentGivenOn = new Date();
        saveToLocalStorage(draft.cookieMeasurement, draft.cookieMarketing, draft.consentGiven, draft.consentGivenOn);
    });
}; };
var loadFromLocalStorage = function () { return function (store) {
    store.setState(function (draft) {
        var c_measurement = localStorage.getItem('cookie_measurement');
        var c_marketing = localStorage.getItem('cookie_marketing');
        var c_given = localStorage.getItem('consent_given');
        var c_given_on = localStorage.getItem('consent_given_on');
        if (c_given && c_given_on && c_measurement && c_marketing) {
            draft.cookieMeasurement = c_measurement == 'true';
            draft.cookieMarketing = c_marketing == 'true';
            draft.consentGiven = c_given == 'true';
            draft.consentGivenOn = new Date(c_given_on);
        }
        draft.initialized = true;
    });
}; };
var setConsentData = function (cookieMeasurement, cookieMarketing, consentGiven, consentGivenOn) { return function (store) {
    store.setState(function (draft) {
        draft.cookieMeasurement = cookieMeasurement;
        draft.cookieMarketing = cookieMarketing;
        draft.consentGiven = consentGiven;
        draft.consentGivenOn = consentGivenOn;
        draft.initialized = true;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        openDialog: openDialog,
        agreeWithSelected: agreeWithSelected,
        agreeWithAll: agreeWithAll,
        loadFromLocalStorage: loadFromLocalStorage,
        setConsentData: setConsentData,
        saveToCurrentUserAccount: saveToCurrentUserAccount,
        setEntityField: setEntityField,
        setStateField: setStateField,
    },
    name: "CookieConsent"
});
var useState = createHook(store);
export { StateDefaults as CookieConsentStateDefaults, useState as useCookieConsent, };
